// ShareBite category-based matching domain module (Task 5.1).
//
// Pure computation of the eligible-NGO set for a Donation's Food Category.
// An NGO is eligible if and only if its Accepted Categories contain the
// Donation's Food Category under exact, case-sensitive equality. The
// computation deliberately considers ONLY the `acceptedCategories` field and
// ignores every other attribute — including any location-related data that may
// be attached to an NGO — so matching is purely category-driven and
// location-independent (Req 7.4).
//
// Design reference: design.md "Property 3: Category-based matching correctness
// and location invariance" and "MatchingService".
// Requirements:
//   7.1 - Identify all NGOs whose Accepted Categories contain the Donation's
//         Food Category using exact category-identifier equality.
//   7.2 - Only NGOs in the eligible set are designated as eligible (no NGO
//         whose Accepted Categories exclude the category is included).
//   7.4 - Distance/location attributes are excluded from the matching
//         computation; identical Food Categories yield identical eligible sets.
/**
 * Compute the eligible-NGO set for a given Donation Food Category.
 *
 * Returns exactly the subset of `ngos` whose `acceptedCategories` contain
 * `foodCategory` under exact, case-sensitive equality, preserving the input
 * order. Every other attribute on an NGO (including any location-related
 * fields) is ignored, so two calls with the same Food Category produce
 * identical eligible sets regardless of location data (Req 7.4).
 *
 * This function is pure: it reads only its arguments and returns a new array
 * without mutating any input or producing side effects.
 *
 * @typeParam T          The concrete NGO type (may carry arbitrary extra fields).
 * @param ngos           The NGOs to evaluate.
 * @param foodCategory   The Donation's Food Category to match against.
 * @returns The NGOs eligible for the given Food Category, in input order.
 */
export function eligibleNGOs(ngos, foodCategory) {
    return ngos.filter((ngo) => ngo.acceptedCategories.includes(foodCategory));
}
//# sourceMappingURL=matching.js.map